import styled, { css } from 'styled-components';

import UI from '#front-credpago';

import globals from '../../globals';

const { containerMaxWidth } = globals;

export const Container = styled.div`
  width: 100%;
  max-width: calc(${containerMaxWidth} + 40px);
  margin: 0 auto;
  align-self: center;
  position: relative;
  padding: 100px 0px;
`;

export const WrapperTitle = styled.div`
  text-align: center;
`;

export const WrapperDescription = styled.div`
  margin: 30px;
`;

export const WrapperTimeline = styled.div`
  display: flex;
  margin-top: 50px;
  margin-bottom: 25px;
  justify-content: center;
  align-items: center;
`;

const timelineModifiers = {
  showBorderLeft: () => css`
    border-width: 3px 3px 0px 0px;
  `,
};

export const Timeline = styled.div`
  ${({ showBorderLeft }) => css`
    display: inline-block;
    width: 13%;
    border-color: #7d7d7d;
    border-style: solid;
    border-width: 3px 3px 0px 3px;
    position: relative;

    @media ${UI.globals.mediaqueries.md}, ${UI.globals.mediaqueries.lg} {
      width: 18%;
    }

    ${!showBorderLeft && timelineModifiers.showBorderLeft()}
  `}
`;

export const WrapperYear = styled.div`
  background: rgba(241, 241, 241, 0.6);
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-bottom: 8px solid #00c6ff;
`;

const pointYearModifiers = {
  left: () => css`
    left: -16px;
  `,

  right: () => css`
    right: -16px;
  `,
};

export const PointYear = styled.div`
  ${({ type }) => css`
    height: 30px;
    width: 30px;
    background: white;
    border: 8px solid #00c6ff;
    border-radius: 50%;
    position: absolute;
    top: 48px;

    ${type === 'left' && pointYearModifiers.left()};
    ${type === 'right' && pointYearModifiers.right()};
  `}
`;

export const Year = styled.p`
  color: #001c4a;
  font-size: 25px;
  margin-bottom: 0px;
  font-family: ${globals.fonts.default};
  font-weight: bold;
`;

export const WrapperContent = styled.div`
  max-height: 250px;
  min-height: 250px;
  overflow: scroll;
  overflow-x: hidden;
  overflow-y: visible;

  &::-webkit-scrollbar {
    width: 8px;
  }

  scrollbar-width: thin;
  scrollbar-color: ${globals.colors.darkBlue} ${globals.colors.lightBlue};

  &::-webkit-scrollbar-track {
    background: ${globals.colors.darkBlue};
    margin: 20px 0px 20px 0px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${globals.colors.lightBlue};
    border: 2px solid ${globals.colors.lightBlue};
  }

  @media ${UI.globals.mediaqueries.md} {
    // max-height: 350px;
    // min-height: 350px;
  }

  @media ${UI.globals.mediaqueries.lg} {
    // width: 18%;
    // max-height: 310px;
    // min-height: 310px;
  }
`;

export const Content = styled.div`
  padding: 10px 16px;

  @media ${UI.globals.mediaqueries.md} {
    padding: 10px 10px;
  }
`;

export const TitleTimeline = styled.div`
  color: #001c4a;
  font-size: 13px;
  font-family: ${globals.fonts.default};
  font-weight: bold;
`;

export const TextTimeline = styled.div`
  color: #7d7d7d;
  font-size: 13px;
  font-family: ${globals.fonts.default};
  font-weight: 500;
`;

const pointModifiers = {
  topLeft: () => css`
    top: -8px;
    left: -8px;
  `,

  topRight: () => css`
    top: -8px;
    right: -8px;
  `,

  bottomLeft: () => css`
    bottom: -8px;
    right: -8px;
  `,

  bottomRight: () => css`
    bottom: -8px;
    left: -7px;
  `,
};

const nextBtn = {
  left: () => css`
    margin-right: 20px;

    @media ${UI.globals.mediaqueries.md} {
      margin-right: 10px;
      margin-left: 10px;
    }
  `,

  right: () => css`
    margin-left: 20px;

    @media ${UI.globals.mediaqueries.md} {
      margin-left: 10px;
      margin-right: 10px;
    }
  `,

  disabled: () => css`
    color: #f1f1f1;
    cursor: not-allowed;
  `,
};

export const NextBtn = styled.div`
  ${({ type, disabled }) => css`
    color: #001c4a;
    font-size: 70px;
    cursor: pointer;

    ${type === 'left' && nextBtn.left()};
    ${type === 'right' && nextBtn.right()};
    ${disabled && nextBtn.disabled()};
  `}
`;

export const PointTimeline = styled.div`
  ${({ type }) => css`
    height: 13px;
    width: 13px;
    background-color: #001c4a;
    border-radius: 50%;
    position: absolute;

    ${type === 'topLeft' && pointModifiers.topLeft()};
    ${type === 'topRight' && pointModifiers.topRight()};
    ${type === 'bottomLeft' && pointModifiers.bottomLeft()};
    ${type === 'bottomRight' && pointModifiers.bottomRight()};
  `}
`;
